//BRAND
export const name = 'Snagcart';
export const company = 'Snagcart';
export const websiteURL = 'https://ailms.snagcart.io';
export const serverURL = 'https://snagcart.onrender.com';
export const logo = 'https://firebasestorage.googleapis.com/v0/b/snagcart-6f136.appspot.com/o/92c32b30-a9e9-4d3d-ad1a-a61738f364c6.jpeg?alt=media&token=5919d283-9439-4150-af64-8fc1e3d3bcd7';
export const razorpayEnabled = false;
export const paypalEnabled = true;
export const stripeEnabled = false;
export const paystackEnabled = false;

//PRICING :-

//FREE 
export const FreeType = 'Free Plan';
export const FreeCost = 0;
export const FreeTime = '';

//MONTHLY 
export const MonthType = 'Monthly Plan';
export const MonthCost = 2;
export const MonthTime = 'month';

//YEARLY 
export const YearType = 'Yearly Plan';
export const YearCost = 99;
export const YearTime = 'year';

//TESTIMONIAL
export const review = "The AI Course Generator revolutionized my content creation process, providing accurate and relevant topics effortlessly. It's a time-saving powerhouse that enhances the quality and relevance of my courses. A must-have tool for educators seeking efficiency and impactful online learning experiences.";
export const from = "Rajarshi";
export const profession = 'CFO at Snagcart';
export const photoURL = 'https://firebasestorage.googleapis.com/v0/b/snagcart-6f136.appspot.com/o/92c32b30-a9e9-4d3d-ad1a-a61738f364c6.jpeg?alt=media&token=5919d283-9439-4150-af64-8fc1e3d3bcd7';

//PAYPAL
export const paypalPlanIdOne = "P-9UN65002JR740234UM2WMRFA";
//PENDING TO CHANGE
export const paypalPlanIdTwo = "P-8T744865W27080359MWOCE5Q";

//RAZORPAY
export const razorpayKeyId = "rzp_test_uqALjZHyTyuiOm";
export const razorpayPlanIdOne = "plan_NMvvtDfznbRp6V";
export const razorpayPlanIdTwo = "plan_NMRc9HARBQRLWA";

//STRIPE
export const stripePlanIdOne = "price_1OTo7CSDXmLtVnVeaHIHxqCj";
export const stripePlanIdTwo = "price_1OTo7eSDXmLtVnVeBbn82U5B";

//PAYSTACK
export const paystackPlanIdOne = "PLN_ouqmm8eo6i2k9k8";
export const paystackPlanIdTwo = "PLN_1v1xqb8io9t5lis";
export const amountInZarOne = '170';
export const amountInZarTwo = '1871';